import React, { useState } from 'react';
import {ReactComponent as Menu} from '../../assets/images/menu.svg';
import {ReactComponent as Close} from '../../assets/images/close.svg';
import {  NavLink } from 'react-router-dom';
const menus = [
    {
        name:'Home',
        target:'/',
        className:""
    },
    {
        name:'About us',
        target:'/about',
        className:""
    },
    {
        name:'Brands',
        target:'/brands',
        className:""
    },
    {
        name:'Men',
        target:'/category/men',
        className:"lg:hidden"
    },
    {
        name:'Women',
        target:'/category/women',
        className:"lg:hidden"
    }
]
const Navbar = () => {
    const [navbarActive, setNavbarActive] = useState(false);
    const handleNavbarToggle  = () => {
        setNavbarActive(!navbarActive);
    }
    return(
        <div className="c-navbar">
            <div className="navbar-toggler cursor-pointer lg:hidden" onClick={handleNavbarToggle}>
                <Menu/>
            </div>
            <div className={`
                navbar-menu 
                z-90 
                fixed 
                top-0 
                left-0 
                h-full 
                overflow-auto
                w-8/12 
                bg-white 
                flex 
                justify-center 
                py-144 
                border-r-1 
                border-gray-200
                transform
                transition-all
                duration-500
                ease-in-out

                
                ${navbarActive?'translate-x-0':'-translate-x-full'}
                lg:relative
                lg:w-full
                lg:border-0
                lg:translate-x-0
                lg:py-0
                lg:bg-transparent
                `}>
                <div className="navbar-close cursor-pointer absolute top-20 right-20 lg:hidden" onClick={handleNavbarToggle}>
                    <Close/>
                </div>
                <ul className="lg:flex navbar-list">
                    {menus.map((item,i)=>{
                        return(
                            <li key={i} className={item.className}>
                                <NavLink exact to={item.target} activeClassName="active font-bold lg:font-normal" className="navbar-link font-light block py-10 lg:py-4 lg:px-16 cursor-pointer xl:text-lg hover:text-gray-400">{item.name}</NavLink>
                            </li>
                        );
                    })}
                    
                </ul>
            </div>
            <div className={`c-navbar-overlay fixed inset-0 h-full w-full bg-transparent  ${navbarActive?'opacity-50 z-20 block':'opacity-0 -z-10 hidden'}`} onClick={handleNavbarToggle}></div>
        </div>
    )
}
export default Navbar;